import React from "react";
import { Container, Row, Col, Table } from "react-bootstrap";
import PaginationLink from "../Components/PaginationLink";
function RichList() {
  return (
    <>
      <div className="main-inner">
        <div className="container-fluid">
          <Row>
            <Container>
              <Row>
                <Col xl="12" md="12">
                  <h2>RichList</h2>
                </Col>
                <Col xl="12" md="12">
                  <div className="table-container">
                    <div className="table-inner-container">
                      <Table hover>
                        <thead>
                          <tr>
                            <th>Ranking</th>
                            <th>address</th>
                            <th>Balance</th>
                            <th>Percentage</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <p>1</p>
                            </td>
                            <td>
                              <h6>
                                0x1050403B7440792baEB8acD780d81e92bC715A6e
                              </h6>
                            </td>
                            <td>
                              <p>83251900.000000 WOOOO</p>
                            </td>
                            <td>
                              <p>333.007600%</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>1</p>
                            </td>
                            <td>
                              <h6>
                                0x1050403B7440792baEB8acD780d81e92bC715A6e
                              </h6>
                            </td>
                            <td>
                              <p>83251900.000000 WOOOO</p>
                            </td>
                            <td>
                              <p>333.007600%</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>1</p>
                            </td>
                            <td>
                              <h6>
                                0x1050403B7440792baEB8acD780d81e92bC715A6e
                              </h6>
                            </td>
                            <td>
                              <p>83251900.000000 WOOOO</p>
                            </td>
                            <td>
                              <p>333.007600%</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>1</p>
                            </td>
                            <td>
                              <h6>
                                0x1050403B7440792baEB8acD780d81e92bC715A6e
                              </h6>
                            </td>
                            <td>
                              <p>83251900.000000 WOOOO</p>
                            </td>
                            <td>
                              <p>333.007600%</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>1</p>
                            </td>
                            <td>
                              <h6>
                                0x1050403B7440792baEB8acD780d81e92bC715A6e
                              </h6>
                            </td>
                            <td>
                              <p>83251900.000000 WOOOO</p>
                            </td>
                            <td>
                              <p>333.007600%</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>1</p>
                            </td>
                            <td>
                              <h6>
                                0x1050403B7440792baEB8acD780d81e92bC715A6e
                              </h6>
                            </td>
                            <td>
                              <p>83251900.000000 WOOOO</p>
                            </td>
                            <td>
                              <p>333.007600%</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>1</p>
                            </td>
                            <td>
                              <h6>
                                0x1050403B7440792baEB8acD780d81e92bC715A6e
                              </h6>
                            </td>
                            <td>
                              <p>83251900.000000 WOOOO</p>
                            </td>
                            <td>
                              <p>333.007600%</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>1</p>
                            </td>
                            <td>
                              <h6>
                                0x1050403B7440792baEB8acD780d81e92bC715A6e
                              </h6>
                            </td>
                            <td>
                              <p>83251900.000000 WOOOO</p>
                            </td>
                            <td>
                              <p>333.007600%</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>1</p>
                            </td>
                            <td>
                              <h6>
                                0x1050403B7440792baEB8acD780d81e92bC715A6e
                              </h6>
                            </td>
                            <td>
                              <p>83251900.000000 WOOOO</p>
                            </td>
                            <td>
                              <p>333.007600%</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>1</p>
                            </td>
                            <td>
                              <h6>
                                0x1050403B7440792baEB8acD780d81e92bC715A6e
                              </h6>
                            </td>
                            <td>
                              <p>83251900.000000 WOOOO</p>
                            </td>
                            <td>
                              <p>333.007600%</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>1</p>
                            </td>
                            <td>
                              <h6>
                                0x1050403B7440792baEB8acD780d81e92bC715A6e
                              </h6>
                            </td>
                            <td>
                              <p>83251900.000000 WOOOO</p>
                            </td>
                            <td>
                              <p>333.007600%</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>1</p>
                            </td>
                            <td>
                              <h6>
                                0x1050403B7440792baEB8acD780d81e92bC715A6e
                              </h6>
                            </td>
                            <td>
                              <p>83251900.000000 WOOOO</p>
                            </td>
                            <td>
                              <p>333.007600%</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>1</p>
                            </td>
                            <td>
                              <h6>
                                0x1050403B7440792baEB8acD780d81e92bC715A6e
                              </h6>
                            </td>
                            <td>
                              <p>83251900.000000 WOOOO</p>
                            </td>
                            <td>
                              <p>333.007600%</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>1</p>
                            </td>
                            <td>
                              <h6>
                                0x1050403B7440792baEB8acD780d81e92bC715A6e
                              </h6>
                            </td>
                            <td>
                              <p>83251900.000000 WOOOO</p>
                            </td>
                            <td>
                              <p>333.007600%</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>1</p>
                            </td>
                            <td>
                              <h6>
                                0x1050403B7440792baEB8acD780d81e92bC715A6e
                              </h6>
                            </td>
                            <td>
                              <p>83251900.000000 WOOOO</p>
                            </td>
                            <td>
                              <p>333.007600%</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>1</p>
                            </td>
                            <td>
                              <h6>
                                0x1050403B7440792baEB8acD780d81e92bC715A6e
                              </h6>
                            </td>
                            <td>
                              <p>83251900.000000 WOOOO</p>
                            </td>
                            <td>
                              <p>333.007600%</p>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                      <div className="pagination-container">
                        {/* <PaginationLink /> */}
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </Row>
        </div>
      </div>
    </>
  );
}
export default RichList;
